import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { logDevError, updateErrorMessage } from 'shared/alerts';

export const RELEASE_HELD_SEATS = gql`
  mutation ReleaseSeatsHold($input: ReleastSeatsHoldInput!) {
    releaseSeatsHold(input: $input)
  }
`;

export function useReleaseSeatsHold() {
  const [releaseSeatsHoldMutation] = useMutation(RELEASE_HELD_SEATS);

  const releaseSeatsHold = useCallback(
    async (input) => {
      try {
        const response = await releaseSeatsHoldMutation({
          variables: { input },
          onError: () => updateErrorMessage('Error releasing seats'),
        });

        return response;
      } catch (error) {
        logDevError(error);
        updateErrorMessage('Error releasing seats');
      }
    },
    [releaseSeatsHoldMutation]
  );

  return releaseSeatsHold;
}
